import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExamDialogBoxComponent } from '../exam-dialog-box/exam-dialog-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-exam-data', 
  templateUrl: './exam-data.component.html',
  styleUrls: ['./exam-data.component.scss'],
})
export class ExamDataComponent implements OnInit {
  APIService: any;
  dialogRef: MatDialogRef<any>;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  examDataSearchForm: any;
  examList: any;
  SessionNo: any;
  UserCollege
  userPermission
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private dialog:MatDialog,
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.examDataSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.getExamAllData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getExamAllData();
    // this. keypress();
  }

  getExamAllData() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage; 
    payload['CgCode'] = this.UserCollege
    this.umsService.getExam(payload).subscribe((res) => {
      this.spinner.hide();
      this.examList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.examList = [];
    let payload = {}
    payload['SearchString'] = this.examDataSearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.getExam(payload).subscribe(res => {
      if(res.status){
        this.examList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.examList = []
        this.totalItems = 0;
      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.examList = [];
    });
    },1000)
    
  }

  addnewrecord() {
    const myData = {
      "EmStreams": "N",
      "EmMarkList": "Gen",
      "EmLatEntry": "N",
      "EmRejImpr": "N",
      "EmVal": 1,
      "EmValDev": 15,
      "EmDiv": "N",
      "EmConv": "N",
      "EmId": 0
    };
    const dialogRef = this.dialog.open(ExamDialogBoxComponent, {
      width: '170vh',
      data: {selected: myData ,key : "New"},
      disableClose: true 
    }); 
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getExamAllData();
      this.examDataSearchForm.controls['SearchString'].setValue('');
    });
  }
  editData(k){ 
    const dialogRef = this.dialog.open(ExamDialogBoxComponent, {
      width: '170vh',
      // height:'85vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getExamAllData();
      this.examDataSearchForm.controls['SearchString'].setValue('');
    });
  }
  deleteData(k){
    const dialogRef = this.dialog.open(ExamDialogBoxComponent, {
      width: '170vh',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getExamAllData();
      this.examDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  
  Print(){
    let submitpayload = this.examDataSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-Exam';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 110,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}